import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function ShippingDisplay() {
  const { shippingAddress } = useAuth();
  const navigate = useNavigate();

  if (!shippingAddress) {
    navigate('/shippingaddress');
    return null;
  }

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>📦 Review Shipping Address</h2>

      <div style={styles.card}>
        <InfoRow label="Name" value={shippingAddress.fullName} />
        <InfoRow label="Address" value={shippingAddress.address} />
        <InfoRow label="City" value={shippingAddress.city} />
        <InfoRow label="Post Code" value={shippingAddress.postcode} />
        <InfoRow label="Country" value={shippingAddress.country} />
      </div>

      <div style={styles.buttonGroup}>
        <button style={styles.secondaryButton} onClick={() => navigate('/shippingaddress')}>
          ✏️ Edit
        </button>
        <button style={styles.primaryButton} onClick={() => navigate('/order-summary')}>
          ✅ Continue to Order Summary
        </button>
      </div>
    </div>
  );
}

const InfoRow = ({ label, value }) => (
  <p style={styles.infoRow}>
    <strong>{label}:</strong> {value}
  </p>
);

const styles = {
  container: {
    maxWidth: '600px',
    margin: 'auto',
    padding: '1rem',
    fontFamily: 'system-ui, sans-serif',
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem',
  },
  title: {
    fontSize: '1.5rem',
    textAlign: 'center',
    color: '#222',
  },
  card: {
    border: '1px solid #ddd',
    borderRadius: '10px',
    padding: '1rem',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    backgroundColor: '#fff',
  },
  infoRow: {
    margin: '0.5rem 0',
    fontSize: '1rem',
    color: '#333',
  },
  buttonGroup: {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.75rem',
    marginTop: '1rem',
  },
  primaryButton: {
    padding: '12px',
    backgroundColor: '#007bff',
    color: 'white',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
  },
  secondaryButton: {
    padding: '12px',
    backgroundColor: '#f0f0f0',
    color: '#333',
    fontSize: '1rem',
    border: '1px solid #ccc',
    borderRadius: '8px',
    cursor: 'pointer',
  },
};

export default ShippingDisplay;
